import './styles.scss'
import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { useDispatch } from 'react-redux'
import { apiConversation } from 'api'
import { Collapse, Button } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { composerAct } from '../../../../redux/actions'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'


const PluginRedirect = ({ userId }) => {

  const dispatch = useDispatch()
  const onChatComposer = bindActionCreators(composerAct, dispatch)

  const [cardOpen, setCardOpen] = useState(false)
  const [urlRedirect, setUrlRedirect] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const toggleCard = () => {
    setCardOpen(!cardOpen)
  }

  const getRedirectUrl = async () => {
    try {
      setIsLoading(true)
      const { data } = await apiConversation.conversations.getRedirectUrl({ userId })
      const { url } = data
      setUrlRedirect(url)
      setTimeout(() => {
        setIsLoading(false)
      }, 300)
    } catch (e) {
      console.error('e: ', e)
    }
  }

  const sendUrlToChat = () => {
    if (!urlRedirect) return
    setIsLoading(true)
    onChatComposer.addExternalText(`${urlRedirect}`)
    setTimeout(() => {
      setCardOpen(false)
      setIsLoading(false)
      setUrlRedirect('')
    }, 300)
  }

  return (
    <div className={`plugin-redirect-card`}>
      <div className='title-container'>
        <div
          className='title'
          onClick={toggleCard}
        >
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-world-web-black.svg')} alt='Redirect' />
          </figure>
          <p>{I18n.t('dashboard_redirect_link')}</p>
        </div>
        <div
          className='action-buttons-container'
          onClick={toggleCard}
        >
          <i className={`fa fa-chevron-${cardOpen ? 'up' : 'down'}`} />
        </div>
      </div>
      <Collapse isOpen={cardOpen}>
        <div className='redirect-container'>
          <div className='separator'></div>
          {
            isLoading ? (
              <div className='loading-container'>
                <Nixi1Spinner width='24px' height='24px' />
              </div>
            ) : (
              <>
                {!urlRedirect && <Button color='primary' onClick={getRedirectUrl}>{I18n.t('dashboard_create-link')}</Button>}
                {urlRedirect && <Button color='secondary' onClick={sendUrlToChat}>{I18n.t('dashboard_copy-to-chat')}</Button>}
              </>
            )
          }
        </div>
      </Collapse>
    </div>
  )
}

export default PluginRedirect
